import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 999,
            color: '#fff',
        },
    }));
};
